import { takeEvery } from 'redux-saga/effects';
import { DOM } from '@app/utils';
import { PAGEVIEW } from '../consts';
import { PageviewTrackAction, TrackingProperties } from '../types';
import isGAReady from '../utils/isGAReady';
import decorateAnalytics from '../utils/decorateAnalytics';
import { GTM } from '../../clients';
import { buildGlobalDecorators } from './utils';

/**
 * GDPR referrer workaround
 **/
const getStoredReferrer = () => {
  const { referrer } = DOM.getLocalStorage('stockx_attribution_referrer') || {};

  if (!referrer) {
    return null;
  }

  return referrer;
};

/**
 * @param pageType
 * @param properties
 */
export function* onPageview({ payload }: PageviewTrackAction) {
  if (typeof window === 'undefined' || payload == null) {
    return;
  }

  const { properties, decorators = {} } = payload;

  const path: string = window.location.pathname;

  if (isGAReady()) {
    const decoratorData = yield* buildGlobalDecorators(decorators);

    //
    // Merge default properties with pageview specific properties
    let propertiesToTrack: TrackingProperties = {
      ...decorateAnalytics(decoratorData, 'ga'),
      ...properties,
    };

    //
    // Only using during GDPR
    const referrer = getStoredReferrer();
    if (referrer) {
      propertiesToTrack = {
        ...propertiesToTrack,
        referrer,
      };
    }

    window.ga('set', 'page', path);
    window.ga('send', 'pageview', propertiesToTrack);
  }

  if (window.RISKX) {
    window.RISKX.go(path);
  }

  GTM.pageView(path);
}

export default function* pageviewSaga() {
  yield takeEvery(PAGEVIEW, onPageview);
}
